<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div> -->
                <div class="col-xl-4 col-lg-6">
                    <stats-card type="gradient-info"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <p style="font-size: 14px">รายได้รวม (บาท)</p>
                        <b>{{this.cardData.summary}} ฿</b>
                        <p style="font-size:12px">ประจำเดือนนี้</p>

                        <!-- <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template> -->
                    </stats-card>
                </div>
            </div>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h5 class="text-uppercase ls-1 mb-1">กราฟแสดงข้อมูลย้อนหลัง</h5>
                                <h5 class="h3 mb-0">สถิติการใช้งานทั้งหมด</h5>
                            </div>
                            <!-- <div class="col">
                                <ul class="nav nav-pills justify-content-end">
                                    <li class="nav-item mr-2 mr-md-0">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 0}"
                                           @click.prevent="initBigChart(0)">
                                             <span class="d-none d-md-block">เดือน</span>
                                             <span class="d-md-none">ด</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link py-2 px-3"
                                           href="#"
                                           :class="{active: bigLineChart.activeIndex === 1}"
                                           @click.prevent="initBigChart(1)">
                                             <span class="d-none d-md-block">วัน</span>
                                             <span class="d-md-none">ว</span>
                                        </a>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                        <!-- <line-chart
                                :height="350"
                                ref="bigChart"
                                :chart-data="bigLineChart.chartData"
                                :extra-options="bigLineChart.extraOptions"
                        >
                        </line-chart> -->
                        <bar-chart
                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </bar-chart>

                    </card>
                </div>

                <!-- <div class="col-xl-4">
                    <card header-classes="bg-transparent">
                        <div slot="header" class="row align-items-center">
                            <div class="col">
                                <h6 class="text-uppercase text-muted ls-1 mb-1">Performance</h6>
                                <h5 class="h3 mb-0">Total orders</h5>
                            </div>
                        </div>

                        <bar-chart
                                :height="350"
                                ref="barChart"
                                :chart-data="redBarChart.chartData"
                        >
                        </bar-chart>
                    </card>
                </div> -->
            </div>
            <!-- End charts-->

            <!--Tables-->
            <div class="row mt-5">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <div class="card">
                      <div class="card-header border-0">
                        <div class="row align-items-center">
                          <div class="col">
                            <h3 class="mb-0">การใช้งานตามเวลา</h3>
                          </div>
                          <div class="col text-right">
                            <a href="#/deposit" class="btn btn-sm btn-primary">ดูทั้งหมด</a>
                          </div>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <base-table thead-classes="thead-light"
                                    :data="tableData">
                          <template slot="columns">
                            <th style="font-size:14px">เวลา</th>
                            <th style="font-size:14px">การใช้งาน (ครั้ง)</th>
                            <th style="font-size:14px">ยอดใช้งาน (บาท)</th>
                          </template>

                          <template slot-scope="{row}">
                            <th scope="row">
                              {{row.start_time}} - {{row.to_time}}
                            </th>
                            <td>
                              {{row.used}}
                            </td>
                            <td>
                              {{row.amount}} ฿
                            </td>
                            <!-- <td>
                              <i class="fas fa-arrow-up text-success mr-3"
                                 :class="row.bounceRateDirection === 'up' ? 'text-success': 'text-danger'">
                              </i>
                              {{row.bounceRate}}
                            </td> -->
                          </template>

                        </base-table>
                      </div>

                    </div>
                </div>
                <!-- <div class="col-xl-4">
                    <social-traffic-table></social-traffic-table>
                </div> -->
            </div>
            <!--End tables-->
        </div>

    </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  // import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Tables
  import SocialTrafficTable from './Dashboard/SocialTrafficTable';
  import PageVisitsTable from './Dashboard/PageVisitsTable';

  import JwService from '../service/justwash';

  export default {
    components: {
      // LineChart,
      BarChart,
      PageVisitsTable,
      SocialTrafficTable,
    },
    data() {
      return {
        tableData: null,
        cardData: {},
        // bigLineChart: {
        //   allData: [
        //     this.cardData.graph_summary
        //     [0, 20, 10, 30, 15, 40, 20, 60, 30, 50, 80, 60],
        //     [0, 20, 5, 25, 10, 30, 15, 40, 35, 60, 80, 60]
        //   ],
        //   activeIndex: 0,
        //   chartData: {
        //     datasets: [],
        //     labels: [],
        //   },
        //   extraOptions: chartConfigs.blueChartOptions,
        // },
        // redBarChart: {
        //   chartData: {
        //     labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        //     datasets: [{
        //       label: 'Sales',
        //       data: [25, 20, 30, 22, 17, 29]
        //     }]
        //   }
        // }
        // bigLineChart: {
        //   chartData: {
        //
        //   }
        // }
        redBarChart: {
          chartData: {

          }
        }
      };
    },
    // methods: {
    //   initBigChart(index) {
    //     var dt = new Date();
    //     var y = dt.getFullYear();
    //     var m = dt.getMonth() + 1;
    //     // var d = dt.getDate();
    //     // var w = dt.getDay();
    //     var datenums = new Date(y, m, 0).getDate();
    //     var datenum = [];
    //     for (var i = 1; i <= datenums; i++) {
    //       datenum.push(i);
    //     }
    //     // alert(datenum);
    //     // console.log(datenum);
    //     let chartData = {
    //       // console.log(this.bigLineChart.activeIndex)
    //       datasets: [
    //         {
    //           label: 'รายได้',
    //           data: this.redBarChart.allData[index]
    //         }
    //       ],
    //       labels: datenum,
    //     };
    //     // console.log(this.bigLineChart.activeIndex)
    //     // this.bigLineChart.chartData = chartData;
    //     // this.bigLineChart.activeIndex = index;
    //   }
    // },
    mounted() {
      // alert(JwService.getAPI());
      // this.initBigChart(0);
      // localStorage.getItem('accessToken');
      // console.log('Token '+localStorage.getItem('accessToken'));
      // var token = localStorage.getItem('accessToken');
      // console.log('Token '+token);
      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.WashingMachineStats',
        data: {
          washing_machine_id : this.$route.params.id
        },
        headers: {
          // 'Authorization' : 'Token EHlTakWH6zSU6m6Lh6kvlg'
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        if (response.data.message.status == true) {
          var dt = new Date();
          var y = dt.getFullYear();
          var m = dt.getMonth() + 1;
          // var d = dt.getDate();
          // var w = dt.getDay();
          var datenums = new Date(y, m, 0).getDate();
          var datenum = [];
          for (var i = 1; i <= datenums; i++) {
            datenum.push(i);
          }
          this.cardData = response.data.message.data
          this.tableData = response.data.message.data.time_stats
          // console.log(this.cardData.graph_summary);
          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.cardData);
          // console.log(response.data.message.data.graph_summary);
          this.redBarChart.chartData = {
            labels: datenum,
            datasets: [{
              label: 'รายได้',
              data: response.data.message.data.graph_summary
            }]
          }
          // this.$router.push('/dashboard')
        } else {
          this.$router.push('/login')
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });
    }
  };
</script>
<style></style>
